'use strict';

angular.module('atex.dam').directive('disableDrop', function() {
  return {
    scope : false,
    link : function(scope, element, attrs) {
      element.on('dragenter dragover drop', function(event) {
        event.originalEvent.dataTransfer.dropEffect = 'none';
        event.preventDefault();
      });
    }
  };
});
